<template>
    <b-card no-body style="width: 100%;">
        <b-card-body class="chart-container">
            <apexchart
                type="bar"
                height="350"
                :options="chartOptions"
                :series="series"
            ></apexchart>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    props: {
        countries: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 350,
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        borderRadius: 5,
                        borderRadiusApplication: 'end',
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent'],
                },
                xaxis: {
                    categories: [], // Will be populated dynamically
                    labels: {
                        style: {
                            fontSize: '14px',
                            fontFamily : "droid"
                        },
                    },
                },
                yaxis: {
                    title: {
                        text: 'عدد الطلاب', // Arabic label for the y-axis
                        style: {
                            fontSize: '14px',
                            fontFamily : "droid"
                        },
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + ' طالب'; // Arabic label in tooltip
                        },
                    },
                },
                title: {
                    text: "أكثر ثماني دول من حيث عدد الطلاب", // Arabic title for the chart
                    align: 'center',
                    style: {
                        fontSize: '22px',
                        fontFamily : "droid"
                    },
                },
            },
            series: [
                {
                    name: 'عدد الطلاب', // Arabic label for the series
                    data: [], // Will be populated dynamically
                },
            ],
        };
    },
    computed: {
        topCountries() {
            // Sort countries by total_students in descending order
            return this.countries
                .slice()
                .sort((a, b) => b.total_students - a.total_students)
                .slice(0, 8); // Get the top 8 countries
        },
    },
    watch: {
        topCountries: {
            immediate: true,
            handler(newVal) {
                // Update chart data dynamically
                this.chartOptions.xaxis.categories = newVal.map(
                    (country) => country.country_name
                );
                this.series[0].data = newVal.map(
                    (country) => country.total_students
                );
            },
        },
    },
};
</script>

<style scoped>
.chart-container {
    width: 100%;
    padding: 8; /* Remove padding if necessary */
}

.chart-container .apexcharts-canvas {
    width: 100% !important;
}
</style>